import { api } from "./api";

export const studentImportOnlyV1 = async (data) => {
  return await api.post("/student/import/only/v1", data);
};

export const studentBulkFeeUpdate = (data) => {
  return api.post("/student/fee/update-bulk", data);
};

export const studentBulkRteUpdate = (data) => {
  return api.post("/student/bulk-rte-update", data);
};

export const studentImportEnrollBatchV1 = async (data) => {
  return await api.post("/student/import/enroll-batch/v1", data);
};

export const studentImportEnrollBatchV2 = async (data) => {
  return await api.post("/student/import/enroll-batch/v2", data);
};

export const batchEnrolledStudentsV0 = async (params) => {
  return await api.get(`/batch/enrolled-students/v0?${params}`);
};

export const StudentFeeUpdateImportV0 = async (data) => {
  return await api.post("/student/import/fee-update/v0", data);
};

export const StudentImportEnrollOnlyV0 = async (data) => {
  return await api.post("/student/import/enroll-only/v0", data);
};

export const StudentPaymentImportV0 = async (data) => {
  return await api.post("/student/import/payment/v0", data);
};

export const StudentProfileUpdateImportV0 = async (data) => {
  return await api.post("/student/import/update/v0", data);
};

// export const studentImportEnrollOnly = async (data) => {
//     return await api.post('/student/import/enroll-only', data);
// };

// export const batchEnrolledStudents = async (params) => {
//     return await api.get(`/batch/enrolled-students?${params}`);
// };

// export const studentImportEnrollHostel = async (data) => {
//     return await api.post(`/student/import/enroll-hostel`, data);
// };

// export const studentUpdate = async (data) => {
//     return await api.post('/student/update', data);
// };

// export const StudentFeeUpdateImport = async (data) => {
//     return await api.post('/student/import/fee-update', data);
// };

// export const StudentPaymentImport = async (data) => {
//     return await api.post('/student/import/payment', data);
// };

// export const StudentProfileUpdateImport = async (data) => {
//     return await api.post('/student/profile/update/import', data);
// };

export const studentProfilePictureBulkUpload = async (formData) => {
  return await api.post("/student/import/profile-picture/v0", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// export const studentProfilePictureBulkUpload = (formData) => {
//   return api.post("/student/profile-picture/bulk-upload", formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
// };

export const studentProfilePictureUrlBulkUpload = (payload) => {
  return api.post("/student/profile-picture/url-bulk-upload", payload);
};
